// extracted by mini-css-extract-plugin
export default {"image":"ResizedImage_image__GEo07","button":"ResizedImage_button__lenqU"};